'use client';

import { useMemo, useState } from 'react';
import Link from 'next/link';
import { usePathname } from 'next/navigation';
import { Box, Drawer, List, Divider, ListItem, ListItemButton, ListItemIcon, ListItemText, IconButton } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import { IconSvg, IconType } from '../Icon';
import { ROUTES } from '@/utils/constants';
import Logo from '@/components/widgets/Logo';
const navItems: {
  title: string;
  url: string;
  icon: IconType;
}[] = [{
  title: 'جذب سرمایه',
  url: ROUTES.fundraiser.root.href,
  icon: 'InvestMenu'
}, {
  title: ROUTES.about.name,
  url: ROUTES.about.href,
  icon: 'ProfileMenu'
}];
export default function DrawerMenu() {
  const pathname = usePathname();
  const activeIndex = useMemo(() => {
    return navItems.findIndex(menu => pathname?.includes(menu.url));
  }, [pathname]);
  const [open, setOpen] = useState(false);
  const toggleDrawer = (open: boolean) => () => setOpen(open);
  const DrawerList = <Box role='presentation' onClick={toggleDrawer(false)} sx={{
    width: 300
  }}>
      <List>
        <ListItem sx={{
        py: 'var(--spacing_m_nudge)'
      }}>
          <Logo />
        </ListItem>
      </List>
      <Divider />
      <List sx={{
      pt: 'var(--spacing_m_nudge)'
    }}>
        {navItems.map((item, index) => <ListItem key={item.title + '_drawer_menu'} disablePadding>
            <ListItemButton LinkComponent={Link} href={item.url} sx={{
          py: 'var(--spacing_xs)'
        }}>
              <ListItemIcon>
                <IconSvg component={item.icon} fill={index === activeIndex ? '#007AFF' : 'rgba(0, 0, 0, 0.6)'} width='24' height='24' />
              </ListItemIcon>
              <ListItemText primary={item.title} sx={{
            typography: 'bodyMedium__Wallfund',
            color: index === activeIndex ? '#007AFF' : 'text.text'
          }} />
            </ListItemButton>
          </ListItem>)}
      </List>
    </Box>;
  return <Box sx={{
    display: {
      xs: 'block',
      md: 'none'
    }
  }} data-sentry-element="Box" data-sentry-component="DrawerMenu" data-sentry-source-file="DrawerMenu.tsx">
      <IconButton onClick={toggleDrawer(true)} aria-label='menu' sx={{
      bgcolor: 'unset',
      p: '5px'
    }} data-sentry-element="IconButton" data-sentry-source-file="DrawerMenu.tsx">
        <MenuIcon sx={{
        width: 30,
        height: 30
      }} data-sentry-element="MenuIcon" data-sentry-source-file="DrawerMenu.tsx" />
      </IconButton>

      <Drawer open={open} onClose={toggleDrawer(false)} sx={{
      '& .MuiDrawer-paper': {
        borderRadius: 'var(--corner_radius_xl) 0 0 var(--corner_radius_xl) '
      }
    }} data-sentry-element="Drawer" data-sentry-source-file="DrawerMenu.tsx">
        {DrawerList}
      </Drawer>
    </Box>;
}